import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { SessionStorageService } from "@services/session-storage";
import { getCurrentUserRole } from "@root/store/selectors/entities/auth";

// Component to restore currentUserRole from Redux to sessionStorage on app load
export function SessionRoleRestorer({
  children,
}: {
  children: React.ReactNode;
}) {
  const sessionStorageService = new SessionStorageService();
  const currentUserRole = useSelector(getCurrentUserRole);

  useEffect(() => {
    // Restore currentUserRole from Redux to sessionStorage after persist gate loads
    if (currentUserRole && !sessionStorageService.hasActiveRole()) {
      sessionStorageService.setCurrentRole(currentUserRole);
      console.log(
        "[App] Restored currentUserRole from Redux:",
        currentUserRole
      );
    }
  }, [currentUserRole]);

  return <>{children}</>;
}
